import { z } from 'zod';
/** Motivos de denúncia mostrados ao usuário (moderação de conteúdo entre pessoas). */
export const reportReasonSchema = z.enum([
    'spam',
    'assedio',
    'conteudo_improprio',
    'golpe',
    'outro',
]);
export const createReportSchema = z
    .object({
    /** @usuário denunciado (sem o domínio), quando a denúncia é de uma pessoa. */
    reportedUsername: z
        .string()
        .trim()
        .toLowerCase()
        .regex(/^[a-z0-9](?:[a-z0-9._]{1,30}[a-z0-9])?$/)
        .optional(),
    /** Conversa ou grupo onde aconteceu. */
    roomId: z.string().trim().min(1).max(255).optional(),
    /** Mensagem específica, quando a denúncia partiu de um balão. */
    eventId: z.string().trim().min(1).max(255).optional(),
    reason: reportReasonSchema,
    note: z.string().trim().max(500).optional(),
})
    .refine((value) => value.reportedUsername || value.roomId, {
    message: 'Diga quem ou qual conversa está sendo denunciada.',
});
export const reportReceiptSchema = z.object({
    id: z.uuid(),
    createdAt: z.iso.datetime(),
});
